import { ContentType, OutcomeContent } from 'types/data'

export const isLessonTile = (content: OutcomeContent) =>
  [ContentType.CHAPTER, ContentType.SUBCHAPTER, ContentType.MODULE].includes(
    content.contentType,
  )
